import React from 'react';
import { DatePicker, Row, Col, Space, Typography, Dropdown, Menu, Button, Segmented, Card, Tooltip, Divider } from "antd";
import {
    BankOutlined, DeleteFilled, DollarOutlined, DownloadOutlined, DownOutlined,
    FileDoneOutlined, FileExcelFilled, FileTextOutlined, FolderOutlined, PlusOutlined,
    SyncOutlined, LockOutlined, DeleteOutlined, CheckCircleOutlined, SolutionOutlined,
    BookOutlined, AuditOutlined, BuildOutlined, SettingOutlined, UnlockOutlined,
    CloudDownloadOutlined, PieChartOutlined, LayoutOutlined
} from '@ant-design/icons';
import { toast } from "react-toastify";

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

const ToolbarButton = ({ icon, label, shortcut, onClick, disabled, danger }) => {
    const handleClick = (e) => {
        console.log(`ToolbarButton clicked: ${label}`);
        if (onClick) onClick(e);
    };

    return (
        <Tooltip title={shortcut ? `${label} [Alt+Shift+${shortcut}]` : label} placement="bottom">
            <Button
                type="text"
                onClick={handleClick}
                disabled={disabled}
                danger={danger}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 2,
                    padding: '6px 12px',
                    height: 'auto',
                    minWidth: 54,
                    border: 'none',
                    color: danger ? undefined : '#475569',
                }}
                className="toolbar-btn"
            >
                <span style={{ fontSize: 18, lineHeight: 1, display: 'block' }}>{icon}</span>
                <span style={{ fontSize: 10, fontWeight: 500, whiteSpace: 'nowrap', display: 'block' }}>{label}</span>
            </Button>
        </Tooltip>
    );
};

const ToolbarDivider = () => (
    <div style={{ width: 1, height: 36, backgroundColor: '#e2e8f0', margin: '0 4px', flexShrink: 0 }} />
);

const GroupLabel = ({ children }) => (
    <div style={{
        position: 'absolute',
        bottom: -2,
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: 9,
        color: '#94a3b8',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        whiteSpace: 'nowrap',
        pointerEvents: 'none'
    }}>
        {children}
    </div>
);

const BalanceteHeader = ({
    filterType,
    setFilterType,
    mesCompetencia,
    setMesCompetencia,
    periodo,
    setPeriodo,
    loading,
    downloadBalancete,
    toggleModal,
    periodoFechado,
    uploadObrigacao,
    handleFaturamento,
    filterRef,
    isContador
}) => {

    const handleAction = (key) => {
        console.log('BalanceteHeader handleAction:', key);
        // Ações bloqueadas quando período fechado
        const bloqueadas = ['novo', 'bancarios', 'excel', 'delete', 'regerar', 'bloqueio'];
        if (periodoFechado && bloqueadas.includes(key)) {
            toast.warn("Período contábil fechado. Operação não permitida.");
            return;
        }

        switch (key) {
            case 'novo': toggleModal('editLancamento', true, { reset: true }); break;
            case 'bancarios': toggleModal('lancamentosBancarios', true); break;
            case 'excel': toggleModal('excel', true); break;
            case 'dre': toggleModal('dre', true); break;
            case 'livroRazao': toggleModal('livroRazao', true, { context: 'menu' }); break;
            case 'balanco': toggleModal('balanco', true); break;
            case 'informe': toggleModal('informe', true); break;
            case 'faturamento': handleFaturamento(); break;
            case 'pagamentos': toggleModal('pagamentos', true); break;
            case 'contas': toggleModal('contas', true); break;
            case 'patrimonio': toggleModal('patrimonio', true); break;
            case 'folha': toggleModal('folha', true); break;
            case 'dashboard': toggleModal('dashboard', true); break;

            case 'bloqueio': toggleModal('bloqueio', true); break;
            case 'deletarBloqueio': toggleModal('deletarBloqueio', true); break;
            case 'regerar': toggleModal('regerar', true); break;
            case 'delete': toggleModal('delete', true); break;
            case 'zeramento': toggleModal('zeramento', true); break;
            case 'exportExcel': toggleModal('exportExcel', true); break;
            case 'obrigacao': uploadObrigacao(); break;
            default: break;
        }
    };

    // Menu dropdown para ações administrativas de período
    const menuItems = [
        { key: 'bloqueio', label: 'Bloquear Período', disabled: periodoFechado, icon: <LockOutlined /> },
        { key: 'deletarBloqueio', label: 'Remover Bloqueio', icon: <UnlockOutlined /> },
        { type: 'divider' },
        { key: 'regerar', label: 'Regerar Período', disabled: periodoFechado, icon: <SyncOutlined /> },
        { key: 'zeramento', label: 'Zerar Período', icon: <CheckCircleOutlined /> },
        { type: 'divider' },
        {
            key: 'delete',
            label: <span style={{ color: '#ff4d4f' }}>Excluir Período</span>,
            disabled: periodoFechado,
            icon: <DeleteOutlined style={{ color: '#ff4d4f' }} />
        },
    ];

    const menuProps = {
        items: menuItems,
        onClick: ({ key, domEvent }) => {
            if (domEvent) domEvent.stopPropagation();
            handleAction(key);
        },
    };

    return (
        <Card className="filter-card" bordered={false} style={{ marginBottom: 0, position: 'relative', zIndex: 50 }}>
            {/* Toolbar/Navbar Única */}
            {isContador && (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    padding: '6px 8px',
                    backgroundColor: '#f8fafc',
                    borderRadius: 12,
                    border: '1px solid #e2e8f0',
                    overflowX: 'auto',
                    position: 'relative',
                    zIndex: 51
                }}>
                    {/* FILTRO DE DATA INTEGRADO AO INÍCIO */}
                    <div style={{ display: 'flex', alignItems: 'center', paddingRight: 12, marginRight: 8, borderRight: '1px solid #e2e8f0', paddingBottom: 8, position: 'relative' }}>
                        <Space>
                            <Segmented
                                size="middle"
                                value={filterType}
                                onChange={setFilterType}
                                options={[{ label: "Mensal", value: "mensal" }, { label: "Período", value: "periodo" }]}
                                style={{ backgroundColor: '#f1f5f9' }}
                            />
                            {filterType === "mensal" ? (
                                <DatePicker
                                    ref={filterRef}
                                    picker="month"
                                    value={mesCompetencia}
                                    onChange={setMesCompetencia}
                                    format="MM/YYYY"
                                    allowClear={false}
                                    style={{ width: 120, height: 32, borderRadius: 6 }}
                                    title="Focar no Filtro - Alt+Shift+F"
                                />
                            ) : (
                                <RangePicker
                                    ref={filterRef}
                                    picker="month"
                                    value={periodo}
                                    onChange={setPeriodo}
                                    format="MM/YYYY"
                                    allowClear={false}
                                    style={{ width: 220, height: 32, borderRadius: 6 }}
                                    title="Focar no Filtro - Alt+Shift+F"
                                />
                            )}
                        </Space>
                        <GroupLabel>Período</GroupLabel>
                    </div>

                    {/* GRUPO: Lançamentos */}
                    <div style={{ display: 'flex', alignItems: 'center', position: 'relative', paddingBottom: 8 }}>
                        <ToolbarButton icon={<PlusOutlined />} label="Novo" shortcut="N" onClick={() => handleAction('novo')} disabled={periodoFechado} />
                        {/* GRUPO: Período (dropdown para ações destrutivas) */}
                        <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                            <Dropdown menu={menuProps} trigger={['click']}>
                                <Button
                                    type="text"
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 2,
                                        padding: '6px 12px',
                                        height: 'auto',
                                        minWidth: 54,
                                        border: 'none',
                                        color: '#475569',
                                    }}
                                    className="toolbar-btn"
                                >
                                    <span style={{ fontSize: 18, lineHeight: 1, display: 'block' }}><SettingOutlined /></span>
                                    <span style={{ fontSize: 10, fontWeight: 500, whiteSpace: 'nowrap', display: 'block' }}>Período <DownOutlined style={{ fontSize: 8 }} /></span>
                                </Button>
                            </Dropdown>
                            <GroupLabel>Gerenciar</GroupLabel>
                        </div>
                        <ToolbarButton icon={<BankOutlined />} label="Bancários" shortcut="B" onClick={() => handleAction('bancarios')} disabled={periodoFechado} />
                        <ToolbarButton icon={<FileExcelFilled />} label="Importar" onClick={() => handleAction('excel')} disabled={periodoFechado} />
                        <GroupLabel>Lançamentos</GroupLabel>
                    </div>

                    <ToolbarDivider />

                    {/* GRUPO: Consultas */}
                    <div style={{ display: 'flex', alignItems: 'center', position: 'relative', paddingBottom: 8 }}>
                        <ToolbarButton icon={<BuildOutlined />} label="Patrimônio" shortcut="A" onClick={() => handleAction('patrimonio')} />
                        <ToolbarButton icon={<SolutionOutlined />} label="Folha" onClick={() => handleAction('folha')} />
                        <ToolbarButton icon={<LayoutOutlined />} label="Dashboard" onClick={() => handleAction('dashboard')} />

                        <ToolbarButton icon={<DollarOutlined />} label="Faturamento" onClick={() => handleAction('faturamento')} />
                        <ToolbarButton icon={<DollarOutlined />} label="Pagamentos" onClick={() => handleAction('pagamentos')} />
                        <GroupLabel>Consultas</GroupLabel>
                    </div>

                    <ToolbarDivider />

                    {/* GRUPO: Exportar */}
                    <div style={{ display: 'flex', alignItems: 'center', position: 'relative', paddingBottom: 8 }}>
                        <ToolbarButton icon={<CloudDownloadOutlined />} label="Exportar" shortcut="E" onClick={() => handleAction('exportExcel')} />
                        <GroupLabel>Exportar</GroupLabel>
                    </div>

                    <ToolbarDivider />

                    {/* GRUPO: Relatórios */}
                    <div style={{ display: 'flex', alignItems: 'center', position: 'relative', paddingBottom: 8 }}>
                        <ToolbarButton icon={<DownloadOutlined />} label="Obrigação" onClick={() => handleAction('obrigacao')} />
                        <ToolbarButton icon={<FolderOutlined />} label="Contas" shortcut="C" onClick={() => handleAction('contas')} />
                        <ToolbarButton icon={<PieChartOutlined />} label="DRE" shortcut="D" onClick={() => handleAction('dre')} />
                        <ToolbarButton icon={<BookOutlined />} label="Razão" shortcut="R" onClick={() => handleAction('livroRazao')} />
                        <ToolbarButton icon={<AuditOutlined />} label="Balanço" onClick={() => handleAction('balanco')} />
                        <ToolbarButton icon={<FileDoneOutlined />} label="Informe" onClick={() => handleAction('informe')} />
                        <GroupLabel>Relatórios</GroupLabel>
                    </div>

                    <div style={{ flex: 1 }} />

                    {/* Botão principal à direita */}
                    <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        onClick={downloadBalancete}
                        loading={loading}
                        title="Gerar PDF - Alt+Shift+P"
                        style={{
                            height: 38,
                            borderRadius: 8,
                            fontWeight: 600,
                            padding: '0 20px',
                            backgroundColor: '#005A9E',
                            borderColor: '#005A9E',
                            boxShadow: '0 2px 6px rgba(0,90,158,0.3)'
                        }}
                    >
                        Gerar Balancete
                    </Button>
                </div>
            )}

            <style>{`
                .toolbar-btn:hover:not(:disabled) {
                    background-color: #e0f2fe !important;
                    color: #0369a1 !important;
                }
                .toolbar-btn:active:not(:disabled) {
                    background-color: #bae6fd !important;
                    transform: scale(0.96);
                }
            `}</style>
        </Card>
    );
};

export default BalanceteHeader;
